import { render, staticRenderFns } from "./ManagerCandidatesList.vue?vue&type=template&id=2eae8cb4&scoped=true"
import script from "./ManagerCandidatesList.vue?vue&type=script&lang=js"
export * from "./ManagerCandidatesList.vue?vue&type=script&lang=js"
import style0 from "./ManagerCandidatesList.vue?vue&type=style&index=0&id=2eae8cb4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eae8cb4",
  null
  
)

export default component.exports